/**
 * API service for file metadata operations
 */

/**
 * Get portfolio file metadata including timestamps
 * @returns {Promise<Object>} File metadata
 */
export const getPortfolioMetadata = async () => {
  try {
    const apiUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';
    const apiKey = process.env.REACT_APP_API_KEY;

    if (!apiKey) {
      throw new Error('API key not found');
    }

    const response = await fetch(`${apiUrl}/api/file/portfolio-metadata?api_key=${apiKey}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const metadata = await response.json();
    return metadata;
  } catch (error) {
    console.error('Error fetching portfolio metadata:', error);
    throw error;
  }
};
